import { makeRequest, CommonRequestOptions } from '../makeRequest';

export async function getCourseAssignmentUserCompletion(
   wikiid: number | null,
   userid: number | null,
   common: CommonRequestOptions = {}
): Promise<{ completions: Record<number, number> }> {
   return makeRequest('get', `/course_assignments/completion/${wikiid}/${userid}`, common);
}
